import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getAmountReferrals = (params) => {
    return axios.get(`${backendHost}/api/admin/referrals/bonuses/referrals`, params);
};

export {
    getAmountReferrals
}